import {CognitoUserPool} from 'amazon-cognito-identity-js'
import { COGNITO } from "./../config/aws";

const poolData = {
	UserPoolId: COGNITO.USER_POOL_ID,
	ClientId: COGNITO.APP_CLIENT_ID
}

export default new CognitoUserPool(poolData)